import Component from './Component';

import { createElement } from '../support/dom';

import iconFacebook from '../../images/icon-facebook.svg';
import iconTwitter from '../../images/icon-twitter.svg';
import iconWeChat from '../../images/icon-wechat.svg';
import iconEmail from '../../images/icon-email.svg';

/**
 * Social component defaults.
 */
const networks = {
    facebook: {
        icon: iconFacebook,
        width: 560,
        height: 400,
        url: 'https://www.facebook.com/sharer.php?u={url}'
    },
    twitter: {
        icon: iconTwitter,
        width: 560,
        height: 300,
        url: 'https://twitter.com/intent/tweet?url={url}&text={title}'
    },
    // linkedin: {
    //     icon: iconLinkedIn,
    //     width: 560,
    //     height: 400,
    //     url: 'https://www.linkedin.com/shareArticle?url={url}&title={title}'
    // },
    // weibo: {
    //     icon: faWeibo,
    //     width: 560,
    //     height: 450,
    //     url: 'http://service.weibo.com/share/share.php?url={url}&appkey=&title={text}&pic=&ralateUid='
    // },
    wechat: {
        icon: iconWeChat,
        width: 560,
        height: 400,
        url: '',
    },
    email: {
        icon: iconEmail,
        width: 560,
        height: 400,
        url: 'mailto:?subject={title}&body={text} {url}'
    }
};


class SocialShare extends Component
{
    constructor(element, options)
    {
        super(element, options);

        this.initialize();
    }

    initialize()
    {

        this.options = Object.assign({
            url: '',
            title: '',
            text: '',
        }, this.options);

        this.activeNetworks = this.element.getAttribute('data-networks').split(',');

        this.icons = {};

        this.updateOptions();

        this.render();

        this.bindEvents();
    }

    updateOptions()
    {
        this.options.url   = this.getUrl();
        this.options.title = this.getTitle();
        this.options.text  = this.getDescription();
        this.options.image = this.getImage();
    }

    render()
    {
        this.renderList();
    }

    renderList()
    {
        this.list = createElement('ul', null, {
            class: 'social-share',
        });

        this.element.appendChild(this.list);

        this.renderIcons();
    }

    renderIcons()
    {
        for (let i = 0; i < this.activeNetworks.length; i++)
        {
            let item = createElement('li', null, {});
            let icon = createElement('img', null, {
                src: networks[this.activeNetworks[i]].icon,
            });

            item.appendChild(icon);

            this.list.appendChild(item);

            this.icons[this.activeNetworks[i]] = item;
        }
    }

    getTitle()
    {
        const title = document.querySelector('[property="og:title"]');
        
        return title && title.getAttribute('content');
    }

    getImage()
    {
        const image = document.querySelector('[property="og:image"]');
        
        return image && image.getAttribute('content');
    }

    getDescription()
    {
        const description = document.querySelector('[property="og:description"]');
        
        return description && description.getAttribute('content');
    }

    getUrl()
    {
        const url = document.querySelector('[property="og:url"]');
        
        return url && url.getAttribute('content');
    }

    open(network)
    {
        let options = networks[network];

        if ( ! options)
        {
            return;
        }

        let url = options.url.replace('{url}', encodeURIComponent(this.options.url));
        url = url.replace('{title}', encodeURIComponent(this.options.title));
        url = url.replace('{text}', encodeURIComponent(this.options.text));

        window.open(url, '_blank', `width=${options.width},height=${options.height},toolbar=no,location=no,resizable=no,menubar=no,scrollbars=no,top=${((screen.height - options.height) / 2)},left=${((screen.width - options.width) / 2)}`);
    }

    _handleClick = (e) =>
    {
        let target = e.target;

        while (target.tagName !== 'LI')
        {
            target = target.parentNode;
        }
        
        for (let i in this.icons)
        {
            if (this.icons[i] === target)
            {
                this.open(i);
            }
        }
    }

    bindEvents()
    {
        this.element.addEventListener('click', this._handleClick);
    }
}


export default SocialShare;